<mat-tab-group>
    <mat-tab>
        <ng-template matTabLabel>
            <span>Human + Email Verified
            <br /> {{verifiedContacts[0].TotalContacts | number}}</span>
        </ng-template>
        <app-contact-matrix [data]="verifiedContacts[0]" tabName="verified" (contactClick)="onContactClick()"></app-contact-matrix>
    </mat-tab>
    <mat-tab>
        <ng-template matTabLabel>
            <span>All Contacts
            <br />{{verifiedContacts[1].TotalContacts | number}}</span>
        </ng-template>
        <app-contact-matrix [data]="verifiedContacts[1]" tabName="all" (contactClick)="onContactClick()"></app-contact-matrix>
    </mat-tab>
</mat-tab-group>
